/**
 * Returns true if the current host is not localhost
 */
function isNotLocalHost() {
	return !window.location.host.includes('localhost');
}

/**
 * Set cookie based on name, value and optionally expires
 * Expiration is in milliseconds! Default is set to 1 day.
 */
export function setCookie(
	name: string,
	value: string | number,
	cDomain: string,
	cPath: string,
	cExpires = 24 * 60 * 60 * 1000,
): void {
	const now = new Date();
	const expires = new Date(now.getTime() + cExpires);
	const domain = cDomain && isNotLocalHost() ? ` ;domain=${cDomain};` : '';
	const path = cPath && isNotLocalHost() ? ` ;path=${cPath};` : '';
	document.cookie = `${name}=${value}; expires=${expires.toUTCString()}${domain}${path}`;
}

/**
 * Get cookie value based on the name
 */
export function getCookie(name: string): string | undefined {
	const value = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
	return value ? value.pop() : '';
}
